<template>
  <div
    style="top: 50%; left: 50%; position: absolute; transform: translate(-50%, -50%)">
    <div
      class="animate-spin rounded-full h-5 w-5 border-2 border-gray-300"
      style="border-top-color: #00A0BA"></div>
  </div>
</template>
